const locationAttributesPrefix = "location";
const LocationAttributes = {
  LOCATION_PATHNAME: `${locationAttributesPrefix}.pathname`,
  LOCATION_SEARCH: `${locationAttributesPrefix}.search`,
  LOCATION_HOST: `${locationAttributesPrefix}.host`
};
const userAttributesPrefix = "auth.user";
const UserAttributes = {
  USER_ID: `${userAttributesPrefix}.id`,
  USER_PERMISSIONS: `${userAttributesPrefix}.permissions`
};
const httpAttributesPrefix = "http";
const httpAttributesRequestPrefix = `${httpAttributesPrefix}.request`;
const httpAttributesResponsePrefix = `${httpAttributesPrefix}.response`;
const HttpRequestAttributes = {
  HTTP_REQUEST_URL: `${httpAttributesRequestPrefix}.url`,
  HTTP_REQUEST_TYPE: `${httpAttributesRequestPrefix}.type`,
  HTTP_REQUEST_METHOD: `${httpAttributesRequestPrefix}.method`,
  HTTP_RESPONSE_ERROR: `${httpAttributesResponsePrefix}.error`,
  HTTP_RESPONSE_STATUS_CODE: `${httpAttributesResponsePrefix}.status_code`,
  HTTP_RESPONSE_TRACE_ID: `${httpAttributesResponsePrefix}.traceId`
};
function applyLocationAttrs(span) {
  span?.setAttributes({
    [LocationAttributes.LOCATION_PATHNAME]: window.location.pathname,
    [LocationAttributes.LOCATION_SEARCH]: window.location.search,
    [LocationAttributes.LOCATION_HOST]: window.location.host
  });
}
function applyUserAttrs(span, user) {
  if (user) {
    span?.setAttributes({
      [UserAttributes.USER_ID]: user?.uid,
      [UserAttributes.USER_PERMISSIONS]: user?.permissions?.join()?.substring(0, 10)
    });
  }
}
function applyHttpRequestAttrs(span, url, method, type) {
  span?.setAttributes({
    [HttpRequestAttributes.HTTP_REQUEST_URL]: url,
    [HttpRequestAttributes.HTTP_REQUEST_METHOD]: method,
    [HttpRequestAttributes.HTTP_REQUEST_TYPE]: type
  });
}
function applyHttpResponseAttrs(span, statusCode, traceId, errorMessage) {
  span?.setAttributes({
    [HttpRequestAttributes.HTTP_RESPONSE_STATUS_CODE]: statusCode,
    [HttpRequestAttributes.HTTP_RESPONSE_TRACE_ID]: traceId,
    [HttpRequestAttributes.HTTP_RESPONSE_ERROR]: errorMessage
  });
}
export {
  HttpRequestAttributes,
  LocationAttributes,
  UserAttributes,
  applyHttpRequestAttrs,
  applyHttpResponseAttrs,
  applyLocationAttrs,
  applyUserAttrs
};
//# sourceMappingURL=OtelSpan.js.map
